export default __webpack_public_path__ + "static/exotic_5-c50b92ca7c1b062deece085307edd482.webp";